export default "__VITE_ASSET__BCnLTekC__"